"use client";
import { Badge, Group, Stack, Text, Timeline } from "@mantine/core";
import React from "react";
import { useTranslation } from "react-i18next";

import { Section } from "@/components/general/section";
import { SectionTitle } from "@/components/general/section-title/section-title";

import styles from "./map.module.css";

const categories = ["done", "progress", "planed"] as const;

const categoryColors: Record<(typeof categories)[number], string> = {
    done: "green",
    progress: "orange",
    planed: "gray",
};

const Map = () => {
    const { t } = useTranslation();
    const roadmap = t("roadmap.groups", { returnObjects: true }) as any;

    return (
        <Section variant="blue-cyan" className={styles.mapSection}>
            <SectionTitle title={t("roadmap.title")} subTitle={t("roadmap.subtitle")} isH1 />
            <Stack gap="xl" className={styles.roadMap}>
                {/* Roadmap Timeline */}
                <Timeline className={styles.timeline} active={roadmap.done.length + roadmap.progress.length} bulletSize={24} lineWidth={4}>
                    {/* Legend */}
                    <Group gap="md">
                        {categories.map((cat) => (
                            <Badge key={cat} variant="outline" color={categoryColors[cat]}>
                                {t(`roadmap.legend.${cat}`)}
                            </Badge>
                        ))}
                    </Group>
                    {categories.map((cat) =>
                        roadmap[cat]?.map((step: any, index: number) => (
                            <Timeline.Item
                                key={step.name}
                                color={categoryColors[cat]}
                                title={step.name}
                                lineVariant={
                                    cat === "planed" || (cat === "progress" && index === roadmap[cat].length - 1) ? "dashed" : "solid"
                                }>
                                <Stack gap="sm">
                                    <Text size="sm" c="dimmed">
                                        {step.description}
                                    </Text>
                                </Stack>
                            </Timeline.Item>
                        ))
                    )}
                </Timeline>
            </Stack>
        </Section>
    );
};
export default Map;
